const baseEvent = {
  event: 'loadEventData',
  eventCategory: 'Save for Later',
  nonInteractive: false,
  customMetrics: {},
  customVariables: {},
  _clear: true
}

export default {
  onAddToSaveForLater: (eventLabel: string) => ({
    ...baseEvent,
    eventAction: 'Add',
    eventLabel
  }),
  onRemoveFromSaveForLater: (eventLabel: string) => ({
    ...baseEvent,
    eventAction: 'Remove',
    eventLabel
  }),
  onAddToCartFromSaveForLater: (eventLabel: string) => ({
    ...baseEvent,
    eventAction: 'Add to Cart',
    eventLabel
  }),
}
